import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { whyItWorksPoints } from '../data/content';
export function WhyItWorks() {
  return <section className="w-full bg-sand py-16 sm:py-24" aria-labelledby="por-que-funciona" data-id="element-129" data-mp="2t2lqiv00s3td">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16" data-id="element-130" data-mp="2x3fflrp77onu">
        <div data-id="element-131" data-mp="3kt9mlsmu6j06">
          <SectionHeading align="left" eyebrow="Por qué funciona" title="Por qué este programa funciona" subtitle="Movimiento real. Resultados reales." data-id="element-132" data-mp="3ksq52d13lwmo" />
          <div className="mt-6 space-y-5 text-lg leading-relaxed text-muted sm:text-xl" data-id="element-133" data-mp="3br8vldi74t6y">
            <p data-id="element-134" data-mp="3gp21e5fl7l6p">
              Este no es otro libro de ejercicios genérico. Está diseñado específicamente
              para el cuerpo de las mujeres mayores de 60 años, que necesita movimientos
              suaves, seguros y constantes.
            </p>
            <p data-id="element-135" data-mp="3u8nh3ejc7i51">
              El yoga y el tai chi en silla son las disciplinas más recomendadas para esta
              etapa de la vida porque activan el metabolismo, fortalecen el abdomen y
              reducen el estrés — los tres factores principales que acumulan grasa
              abdominal después de los 60.
            </p>
          </div>
        </div>

        <ul className="flex flex-col gap-4 self-start rounded-4xl border border-linen bg-cream p-7 sm:p-9" data-id="element-136" data-mp="34yp5mgv94y1">
          {whyItWorksPoints.map((point, index) => <motion.li key={point} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.4,
          ease: 'easeOut',
          delay: index * 0.07
        }} className="flex items-start gap-4 border-b border-linen pb-4 last:border-0 last:pb-0" data-id="element-137" data-mp="c2sl2wapxwko" data-mpi={index}>
              <CheckCircle2Icon className="mt-1 h-6 w-6 shrink-0 text-sage" aria-hidden="true" data-id="element-138" data-mp="vsulur6fqwut" />
              <span className="text-lg leading-relaxed text-ink" data-id="element-139" data-mp="12swu81xg7n4l">{point}</span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}